import {
  apiRequest,
  anakCreate,
  masterRegion,
  masterParents,
  masterRelationshipStatus,
  masterMaritalStatus,
  masterGajiwebSatker,
} from "../../../../../../services/adapters/kepegawaian/anakService";

class CreateRepository {
  fetchMaritalStatus = async (query) => {
    return await apiRequest(
      "get",
      masterMaritalStatus,
      {
        params: query,
      },
      true
    );
  };

  fetchRelationshipStatus = async (query) => {
    return await apiRequest(
      "get",
      masterRelationshipStatus,
      {
        params: query,
      },
      true
    );
  };

  fetchRegionCountry = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchParents = async (query) => {
    return await apiRequest(
      "get",
      masterParents,
      {
        params: query,
      },
      true
    );
  };

  fetchRegionProvince = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchRegionCity = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      anakCreate,
      {
        body: query,
      },
      true
    );
  };

  fetchSatkerGajiWeb = async (query) => {
    return await apiRequest(
      "get",
      masterGajiwebSatker,
      {
        params: query,
      },
      true
    );
  };
}

export default CreateRepository;
